import styled from 'styled-components';

export const StyledRow = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 62.5vh;
    margin-bottom: 10em;
    margin-top: 5em;

    h1 {
            text-align: center;
            font: normal bold 28px "Roboto Condensed";
            width: 100%;
        }

    h1.package-heading {
        text-align: center;
        margin: .5em 0 .5em 0;
        font: normal bold 28px "Roboto Condensed";
        width: 100%;
    }
    button {height: 40px; padding: 0 2em; margin-top: 4em;}

`

export const PackagesWrapper = styled.div`
    display: flex;
    flex-direction: row;
    width: 70%;
    max-width: 900px;
    align-items: flex-start;
    margin-top: 5em;
    

    .recommended-package {
        transform: scale(1.125);
        background-color: #000;
    }
`

export const PackageItem = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    border: 1px #999 solid;
    font-family: Roboto;
    width: 33%;

    .selected-package {
        background-color: #75db00;
    }


    div.package-name {
        width: 100%;
        h1.package-title { 
            font-size: 32px; 
            text-transform: uppercase;
            
        }
        p.package-target { font-size: 18px; text-align: center; }
        padding: .5em 1em;
    }

    div.package-value {
        padding: .5em 1em;
        h1.price {
            font-size: 38px;
            color: #acff24;
            text-transform: uppercase;

            span, sup {color: #999; font-size: 15px;}
        }
    }

    div.features-list {
        display: flex;
        flex-direction: column;
        align-items: center;
        text-transform: uppercase;
        font-size: 16px;
        border-top: 1px #999 solid;
        width: 100%;
        padding: 2em 0;

        p {text-align: center;}

        button { padding: 0 2.5em; height: 32px; margin: 1.5em 0; }
    }
`


// WEBPACK FOOTER //
// ./src/pages/Onboard/Packages/Packages.styles.ts